import React, { useEffect, useState, useRef } from "react";
import { DEFAULT_REQUEST_FILTER } from "../../../databucket";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import "./Frames.scss";
import { Form, message, Row, Col, Button } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getOptionsByPath } from "../../../utilsdata";
import {
  faFilter,
  faXmark,
  faCloudArrowDown,
  faSync
} from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from "react-redux";
import { submitRefreshPage, createRequestThunk, fetchAllOrdersThunk, fetchEmployeeClientsThunk } from "../../../Slices/orderSlice";

import dayjs from 'dayjs';
import { useErrorLogger } from "../../../utils";
import AddRequest from "./AddRequest";
import RequestDetails from "./RequestDetails";
import { setLoader } from "../../../Slices/loaderSlice";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable.js";
import { InputField, DatePickerField, SelectInput, AntdButton } from "../../../blueplanitUtils/InputField.jsx";
import { setFilters, setPages } from "../../../Slices/taskSlice.js";
import { REQUEST_INFO, EDIT_REQUEST_STATUS, EDIT_REQUEST_PRIORITY, REQUEST_FILTER, REQUEST_FILTER_STAGE } from '../../../Dropdownmanager.jsx';
import { MailOutlined } from "@ant-design/icons";
const Requests = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch()
  const dropdownRef = useRef(null);
  const filters = useSelector((state) => state.task.filters);
  const pages = useSelector((state) => state.task.pages);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const orders = useSelector((state) => state?.orders?.orders || []);
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);

  const selectedOrder = orders?.filter(item => item?.id === id);
  const loading = useSelector((state) => state?.orders?.loading);
  // Surfaced in the grid below. Previously a failed fetch was indistinguishable
  // from an empty result set — the user saw "No data" and had no way to know
  // the request had actually errored.
  const ordersError = useSelector((state) => state?.orders?.error);

  const totalCount = useSelector((state) => state?.orders?.TotalCount);

  const [filteredOrders, setFilteredOrders] = useState([orders]);
  const [filteredStatus, setFilteredStatus] = useState(filters.filter || DEFAULT_REQUEST_FILTER);
  const [filteredPriority, setFilteredPriority] = useState(filters.priority || "");
  const [filter, setFilter] = useState(Object.keys(filters).length > 1 ? filters : { filter: filters.filter || DEFAULT_REQUEST_FILTER });
  const [dropDownOpen, setDropdownOpen] = useState(false)
  const [open, setOpen] = useState(false);
  const [isRequestAdded, setIsRequestAdded] = useState(false);
  const [form] = Form.useForm();
  const [requestId, setRequestId] = useState(filters.requestId || "");
  const [clientName, setClientName] = useState(filters.clientName || "");
  const [requestStatus, setRequestStatus] = useState("");
  const [date, setDate] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [subject, setSubject] = useState("");
  const [prevVisibility, setDivVisibility] = useState(false);
  const tick = useRef(0);
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const clientsData = useSelector((state) => state?.orders?.getAllClients);
  const [clientEmails, setClientEmails] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState("");
  const { logError } = useErrorLogger();

  const refreshStatus = useSelector((state) => state.orders.refreshPage);


  // Clients assigned to the logged-in user
  const employeeClients = useSelector(
    (state) => state?.loginUserInfo?.loginUserDetails?.client
  ) || [];

  // All available client records (with full details)
  const clientsData1 = useSelector((state) => state?.loginUserInfo?.loginUserDetails?.client);

  const client = useSelector((state) => state?.clients?.clients);
  const clientsDataWithEmails = (clientsData1 || []).map((item) => {
    const matchedClient = client.find((c) => item?.NameOfClient === c?.clientName);
    if (matchedClient) {
      return {
        NameOfClient: item?.NameOfClient,
        emails: matchedClient?.emailId || [],
      };
    }
    return null; // handle cases where no match found
  }).filter(Boolean); // remove nulls

  // const filteredClients = clientsDataWithEmails
  //   .filter(
  //     c =>
  //       typeof c?.emailId === "string" &&
  //       c?.emailId.endsWith("@blueplanitcorp.com")
  //   )
  //   .map(c => c?.emailId,
  //   );

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setIsRequestAdded(!isRequestAdded)
  };
  const handleFilters = () => {
    setDivVisibility((prevVisibility) => !prevVisibility);
  };

  const handleClientNameChange = (value) => {
    setClientName(value);
  };

  const handleSelectClient = (value) => {
    setClientName(value);
  };

  const closeCard = () => {
    setDivVisibility(false);
  };
  const handleKeyDown = (e) => {
    let value = e.target.value.replace(/[^\d/]/g, '');

    if (value.length >= 10 && e.key !== "Backspace") {
      e.preventDefault();
      return;
    }

    value = value
      .replace(/^(\d{2})(\d)$/g, '$1/$2')
      .replace(/^(\d{2}\/\d{2})(\d{1,4})$/g, '$1/$2');
    e.target.value = value;
  };

  useEffect(() => {
    if (!refreshStatus) {
      dispatch(fetchAllOrdersThunk({ page, pageSize, filter, id: loginUser.id }));

    }
  }, [dispatch, page, pageSize, filter, loginUser.id, refreshStatus]);

  const userid = loginUser.id;

  useEffect(() => {
    if (orders && orders.length > 0) {
      setFilteredOrders(orders);
    } else {
      setFilteredOrders([]);
    }
  }, [orders]);

  useEffect(() => {
    dispatch(fetchEmployeeClientsThunk(userid));
  }, [dispatch, userid]);

  useEffect(() => {
    const interval = setInterval(() => {
      tick.current += 1;
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    dispatch(submitRefreshPage(false));
  }, [dispatch, location.pathname]);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    setFilteredStatus(filters.filter || DEFAULT_REQUEST_FILTER);
  }, [filters]);

  const [newRequest, setNewRequest] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);

  const startTimer = () => {
    setIsDisabled(true);
    setTimeout(() => {
      setIsDisabled(false);
    }, 3000);
  };

  const requestSubmit = async (values) => {
    const userid = loginUser
    const { fromEmail, toEmail, Subject, ...newObject } = newRequest;
    const { fromEmal: from, toEmail: to, Subject: subject, ...createdObject } = values;

    if (JSON.stringify(newObject) === JSON.stringify(createdObject)) {
      startTimer();
      message.error({
        content: "You haven't changed anything compared to the last request. Please modify a value before submitting.",
        duration: 3,
        className: 'custom-toast-center',
      });
      return;
    }
    startTimer();
    setNewRequest(values)
    dispatch(setLoader(false))
    try {
      const valuesObject = {
        requestId: values?.requestId,
        subject: values?.subject,
        body: values?.body,
        date: Date.now().toString(),
        dueDate: values.dueDate,
        client: values?.client,
        clientName: values?.clientName,
        priority: values?.priority,
        createdBy: userid.id,
        request_type: values.request_type,
        instructions: values.instructions,
        fromPending: values.fromPending,
        quoteType: values.quoteType,
        department: values.department,
        insuredName: values.insuredName,
        noofQuotes: parseInt(values.noofQuotes),
        holderName: values.holderName,
        insuredDelivery: values.insuredDelivery,
        holderDelivery: values.holderDelivery,
        accountManagerDelivery: values.accountManagerDelivery,
        otherDelivery: values.otherDelivery,
        radioValue: values.radioValue,
        Auto: values.Auto,
        MotorCycle: values.MotorCycle,
        Boat: values.Boat,
        DP3: values.DP3,
        HO3: values.HO3,
        HO4: values.HO4,
        HO5: values.HO5,
        HO6: values.HO6,
        umbrella: values.umbrella,
        flud: values.flud,
        isOthers: values.isOthers,
        others: values.others,
        comments: values.comments,
        processType: values.processType,
        assignedTo: values.assignedTo,
        assignTo: values.assignTo,
        from: values?.from,
        responseStatus: values?.responseStatus,
        to: values?.to,
        requestStatus: values.requestStatus,
        Assign: values.Assign,
        radioInfo: values.radioInfo,
        emailSummary: values.emailSummary,
        requestor: values.requestor,
        sendTo: values.sendTo,
        newQuoteInformation: values.newQuoteInformation.map(({ __typename, ...rest }) => rest),
        existingPolicyInformation: values.existingPolicyInformation.map(({ __typename, ...rest }) => rest)


      }
      dispatch(createRequestThunk(valuesObject))
        .unwrap()
        .then((newRequest) => {
          message.success({
            content: `Request created successfully ${newRequest.requestId}`,
            duration: 5,
            className: 'custom-toast-center',
          });
        })
        .catch(() => {
          setSetPopupStatus(true);
          setSubmitStatus('An error occurred. Please try again.');
        });

    }
    catch (error) {
      dispatch(setLoader(false))
      await logError("Requests", "submit", error.message);
      console.error("Error updating lead:", error);
      message.error({
        content: "Failed to create lead. Please try again.",
        duration: 5,
        className: 'alert alert-danger text-center',
      });
    }

  }

  const priorityHandler = (values) => {
    let priority = values.priority;
    const { body, subject } = values;
    if (body?.toLowerCase().includes("urgent") || body?.toLowerCase().includes("rush") || subject?.toLowerCase().includes("urgent") || subject?.toLowerCase().includes("rush")) {
      priority = 'Rush';
    } else {

    }
    return priority;
  };

  const [popupStatus, setSetPopupStatus] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('')

  const handleDialogClose = async () => {
    setSetPopupStatus(false);
    handleClose()
  };

  const getDateTime = (timeValue) => {
    const startDate = new Date(timeValue).toLocaleDateString();
    const startTimeString = new Date(timeValue).toLocaleTimeString(undefined, { hour12: true });

    const dateTimeString = `${startDate} ${startTimeString}`;

    return dateTimeString;
  }
  const getDueTime = (timeValue, typeValue) => {

    const formattedDateTime = moment(timeValue).format('YYYY-MM-DD HH:mm:ss');

    const newDateTime = moment(formattedDateTime).add(typeValue, 'hours').format('YYYY-MM-DD HH:mm:ss');

    return newDateTime;
  }
  const GetDueDateTemp = (obj) => {
    let priority = obj?.priority;
    let date = obj?.date;
    let dateValue;
    if (priority === 'Rush') {
      dateValue = getDateTime(getDueTime(parseInt(date), 2));
    } else if (priority === 'On Demand') {
      dateValue = getDateTime(getDueTime(parseInt(date), 24));
    } else if (priority === "Bulk") {
      dateValue = getDateTime(getDueTime(parseInt(date), 48));
    }
    return dateValue;
  }

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const handleDetailPage = (record) => {

    navigate(`/request/${record}`)
  }

  const columns = [
    {
      title: "S.NO",
      dataIndex: "sno",
      sorter: (a, b) => a.sno?.length - b.sno?.length,
      width: 50,
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) => {
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <span>{record.sno}</span>
 
            {record.responseStatus ? (
              <MailOutlined style={{ fontSize: 16 }} />
            ) : null}
          </div>
        );
      }
    },
    {
      title: "Request #",
      dataIndex: "requestId",
      width: 80,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: "Received Date",
      dataIndex: "date",
      width: 138,
      render: (text) => dayjs(parseInt(text)).isValid() ? dayjs(parseInt(text)).format('DD/MM/YYYY HH:mm A') : text,
      ellipsis: true,
    },

    {
      title: "Request Type",
      dataIndex: "processType",
      ellipsis: true,
    },
    {
      title: "Insured",
      dataIndex: "insuredName",
      ellipsis: true
    },
    {
      title: "Subject of Email",
      dataIndex: "subject",
      ellipsis: true
    },
    {
      title: "Priority",
      dataIndex: 'priority',
      width: 110,
      ellipsis: true,
      render: (value, record) => {
        const dueDate = new Date(parseInt(record.dueDate));
        const now = new Date();
        const remainingMs = dueDate - now;
        const remainingHours = remainingMs / (1000 * 60 * 60);

        let backgroundColor = '#ffffff';
        const priority = value;

        if (priority === 'Rush') {
          if (remainingHours < 0) {
            backgroundColor = '#ff0000';
          } else if (remainingHours < 1) {
            backgroundColor = '#ff8c00';
          } else {
            backgroundColor = '#ffd900';
          }
        } else if (priority === 'On Demand') {
          if (remainingHours < 0) {
            backgroundColor = '#ff0000';
          } else if (remainingHours < 1) {
            backgroundColor = '#ff8c00';
          } else if (remainingHours < 2) {
            backgroundColor = '#ffa500';
          } else {
            backgroundColor = '#ffffff';
          }
        } else if (priority === 'Bulk') {
          if (remainingHours < 0) {
            backgroundColor = '#ff0000';
          } else if (remainingHours < 2) {
            backgroundColor = '#ff8c00';
          } else if (remainingHours < 4) {
            backgroundColor = '#ffa500';
          } else {
            backgroundColor = '#32cd32';
          }
        }

        return (
          <div
            style={{
              backgroundColor,
              border: '1px solid #d6d6d6',
              paddingRight: '8px',
              display: 'flex',
              alignItems: 'center',
              color: 'black',
              borderRadius: 20,
              paddingLeft: '8px',
              paddingTop: '4px',
              paddingBottom: '4px',
            }}
          >
            {priority || priorityHandler(record)}
          </div>
        );
      }

    },
    {
      title: "Status",
      dataIndex: "requestStatus",
      ellipsis: true,
    },
    {
      title: "Assigned Staff",
      dataIndex: "assignedTo",
      width: 140,
      ellipsis: true,
    },
    {
      title: "Requestor",
      dataIndex: "from",
      ellipsis: true,
    },
    {
      title: "Due Date",
      dataIndex: "dueDate",
      width: 138,
      ellipsis: true,
      render: (value, record) => value ? dayjs(parseInt(value)).format('DD/MM/YYYY HH:mm A') : GetDueDateTemp(record),
    },
    {
      title: "Count",
      dataIndex: "noofQuotes",
      width: 60,
      ellipsis: {
        showTitle: false,
      },
    },

  ];


  const rowsWithSerialNumber = filteredOrders?.length > 0 && filteredOrders?.map((row, index) => ({
    sno: (page - 1) * pageSize + index + 1,
    DueDate: row?.dueDate ? dayjs(parseInt(row?.dueDate)).format('DD/MM/YYYY HH:mm A') : GetDueDateTemp(row),
    Date: dayjs(parseInt(row?.date)).format('DD/MM/YYYY HH:mm A'),
    ...row,
  }));

  const handleRowClick = (record) => {
    dispatch(setFilters(filters));
    dispatch(setPages(pages));
    handleDetailPage(record.id)
  };

  const statusHandler = (value) => {
    setFilter({ filter: value });
    setFilteredStatus(value);
    dispatch(setFilters({ ...filters, filter: value, clientName: clientName || undefined }));
    setPage(1);
  };

  const simulatePrintDialog = (dataToExport, selectedColumns) => {

    const printableContent = document.createElement("div");
    printableContent.style.width = "100%";
    printableContent.style.margin = "0 auto";
    printableContent.style.padding = "5px";
    printableContent.style.fontFamily = "Arial, sans-serif";
    printableContent.style.fontSize = "5px";


    const table = document.createElement("table");
    table.style.width = "100%";
    table.style.border = "1px solid #000";
    table.style.borderCollapse = "collapse";


    const thead = document.createElement("thead");
    const headerRow = document.createElement("tr");

    selectedColumns.forEach(col => {
      const th = document.createElement("th");
      th.style.padding = "2px";
      th.style.textAlign = "left";
      th.style.border = "1px solid #ddd";
      th.innerText = col.toUpperCase();
      headerRow.appendChild(th);
    });
    thead.appendChild(headerRow);
    table.appendChild(thead);


    const tbody = document.createElement("tbody");
    dataToExport.forEach(row => {
      const rowElement = document.createElement("tr");
      selectedColumns.forEach(col => {
        const td = document.createElement("td");
        td.style.padding = "2px";
        td.style.textAlign = "left";
        td.style.border = "1px solid #ddd";
        td.innerText = row[col];
        rowElement.appendChild(td);
      });
      tbody.appendChild(rowElement);
    });

    table.appendChild(tbody);
    printableContent.appendChild(table);


    const printStyle = document.createElement("style");
    printStyle.innerHTML = `
          body * {
            visibility: hidden;
          }
          #print-content, #print-content * {
            visibility: visible;
          }
          #print-content {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: auto;
          }
          table {
            margin-top: 5px;
            width: 100%;
            border: 1px solid black;
            border-collapse: collapse;
          }
          th, td {
            padding: 2px;
            text-align: left;
            border: 1px solid #ddd;
          }
        `;
    document.head.appendChild(printStyle);


    printableContent.id = "print-content";
    document.body.appendChild(printableContent);


    window.print();


    document.body.removeChild(printableContent);
    document.head.removeChild(printStyle);
  };



  const handleExport = (fileFormat) => {
    const selectedColumns = [
      "sno",
      "requestId",
      "Date",
      "processType",
      "insuredName",
      "subject",
      "priority",
      "requestStatus",
      "assignedTo",
      "from",
      "DueDate",
      "noofQuotes"
    ];

    let dataToExport;


    dataToExport = rowsWithSerialNumber;

    if (dataToExport.length > 0) {
      if (fileFormat === "CSV") {

        const csvData = convertToCSV(dataToExport, selectedColumns);
        downloadCSV(csvData, `Report.csv`);
      } else if (fileFormat === "PDF") {
        simulatePrintDialog(dataToExport, selectedColumns);
      }
      setDropdownOpen(false);
    } else {
      alert('No data available for export.');
    }
  }

  const convertToCSV = (data, selectedColumns) => {

    const headers = selectedColumns.join(',');

    const rows = data?.map(row => {
      return selectedColumns?.map(column => {
        let value = row[column] || '';
        if (value instanceof Date) {
          value = dayjs(parseInt(value)).format('DD/MM/YYYY HH:mm A');
        }
        return `"${value}"`;
      }).join(',');
    });

    return [headers, ...rows].join('\n');
  };

  const downloadCSV = (csvData, filename) => {
    const blob = new Blob([csvData], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const clearFilters = () => {
    form.resetFields();

    setRequestId("");
    setClientName("");
    setRequestStatus("");
    setDate(null);
    setDueDate(null);
    setFilteredPriority("");
    setFilteredStatus(DEFAULT_REQUEST_FILTER);
    setFilter({ filter: DEFAULT_REQUEST_FILTER });
    setSubject("")
    setPage(1);
    dispatch(setFilters({ filter: DEFAULT_REQUEST_FILTER }));

    form.setFieldsValue({
      receivedDate: null,
      dueDate: null,
    });
  };


  const handleSearch = async () => {
    setPage(1)
    const filters = {
      requestId: requestId || undefined,
      clientName: clientName || undefined,
      requestStatus: requestStatus || undefined,
      priority: filteredPriority || undefined,
      requestReceivedStartDate: date ? dayjs(date.format('YYYY-MM-DD')).startOf('day').format() : null,
      requestReceivedEndDate: date ? dayjs(date.format('YYYY-MM-DD')).endOf('day').format() : null,
      requestReceivedStartDueDate: dueDate ? dayjs(dueDate.format('YYYY-MM-DD')).startOf('day').format() : null,
      requestReceivedEndDueDate: dueDate ? dayjs(dueDate.format('YYYY-MM-DD')).endOf('day').format() : null,
      textSearch: subject || undefined
    };

    const cleanedFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value !== undefined)
    );

    if (Object.keys(cleanedFilters).length === 0) {
      message.warning("Please select at least one filter before searching.");
      return;
    }

    setFilteredStatus("All")
    setFilter(cleanedFilters);
    dispatch(setFilters({ ...cleanedFilters, filter: "All" }));
  };

return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        {(id !== undefined) ? <RequestDetails handleDetailPage={handleDetailPage} RequestInfo={selectedOrder} /> :
          <>
            {open && <AddRequest isDisabled={isDisabled} open={open} handleClose={handleClose} requestSubmit={requestSubmit} popupStatus={popupStatus} submitStatus={submitStatus} setSetPopupStatus={setSetPopupStatus} handleDialogClose={handleDialogClose} />}
            {!open &&
              <>
 
                <div className="frame-container">
                  <div className={`left-frame ${prevVisibility ? "show" : "hide"}`}>
                    <AntdButton
                      icon={<FontAwesomeIcon icon={faXmark} />}
                      onClick={closeCard}
                      shape="circle"
                      className="card-close-btn"
                    />
                    <div style={{ margin: "9px", marginTop: "20px" }}>
                      <Form form={form}
                        layout="vertical"
                        onFinish={handleSearch}
                        initialValues={{
                          receivedDate: date ? dayjs(date) : null,
                          dueDate: dueDate ? dayjs(dueDate) : null,
                        }}>
                        <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }]} style={{ marginRight: "0px", marginLeft: "0px" }}>
 
                          <Col span={24}>
                            <Form.Item className="form-item-label">
                              <InputField
                                label="RequestId"
                                className="form-input"
                                type="text"
                                name="requestId"
                                value={requestId}
                                placeholder="Select RequestId"
                                onChange={(e) => setRequestId(e.target.value)}
                              />
                            </Form.Item>
                          </Col>
 
                          <Col span={24} style={{ marginTop: "-14px" }}>
                            <Form.Item labelCol={{ span: 24 }} className="form-item-label">
                              <SelectInput
                                label="Client Name"
                                name="clientName"
                                value={clientName || undefined}
                                onChange={handleClientNameChange}
                                onSelect={handleSelectClient}
                                placeholder="Select Client's Name"
                                style={{ marginTop: "-12px" }}
                                options={clientsData?.map((item, key) => (
                                  {
                                    value: item.NameOfClient,
                                    label: item.NameOfClient,
                                  }
 
                                ))}
                                filterOption={(inputValue, option) =>
                                  option && option.value && option.value.toLowerCase().includes(inputValue.toLowerCase())
                                }
                              />
                            </Form.Item>
                          </Col>
 
                          <Col span={24} style={{ marginTop: "-32px" }}>
                            <Form.Item labelCol={{ span: 24 }} className="form-item-label">
                              <DatePickerField
                                label="Received Date"
                                name="receivedDate"
                                className="form-item-label"
                                showTime={false}
                                value={date ? dayjs(date) : null}
                                onChange={(newDate) => {
                                  setDate(newDate);
                                  form.setFieldValue('receivedDate', newDate); // sync form
                                }}
                                style={{ width: "100%", paddingRight: "10px", }}
                                format="DD/MM/YYYY"
                                placeholder="DD/MM/YYYY"
                                allowClear={true}
                                onKeyDown={handleKeyDown}
                                disabledDate={(current) => {
                                  return current && current > dayjs().endOf('day');
                                }}
                              />
                            </Form.Item>
                          </Col>
 
                          <Col span={24} style={{ marginTop: "-32px" }}>
                            <Form.Item labelCol={{ span: 24 }} className="form-item-label">
                              <DatePickerField
                                label="Due Date"
                                name="dueDate"
                                className="form-datepicker"
                                showTime={false}
                                value={dueDate ? dayjs(dueDate) : null}
                                onChange={(newDate) => {
                                  setDueDate(newDate);
                                  form.setFieldValue('dueDate', newDate); // sync form
                                }}
                                format="DD/MM/YYYY"
                                style={{ width: "100%", paddingRight: "10px", }}
                                allowClear={true}
                                placeholder="DD/MM/YYYY"
                                onKeyDown={handleKeyDown}
                              />
                            </Form.Item>
                          </Col>
 
                          <Col style={{ marginTop: "-32px" }} span={24}>
                            <Form.Item labelCol={{ span: 24 }} className="form-item-label">
                              <SelectInput
                                label="Status"
                                className="form-select"
                                size="middle"
                                value={requestStatus || undefined}
                                onChange={(value) => setRequestStatus(value)}
                                style={{ border: "none" }}
                                placeholder="Select Status"
                                options={getOptionsByPath(NestedDatabucket, [REQUEST_INFO, EDIT_REQUEST_STATUS])}
                              />
                            </Form.Item>
                          </Col>
 
                          <Col style={{ marginTop: "-32px" }} span={24}>
                            <Form.Item labelCol={{ span: 24 }} className="form-item-label">
                              <SelectInput
                                label="Priority"
                                className="form-select"
                                size="middle"
                                value={filteredPriority || undefined}
                                onChange={(value) => setFilteredPriority(value)}
                                dropdownStyle={{ minWidth: '160px' }}
                                placeholder="Select Priority"
                                style={{ border: "none" }}
                                options={getOptionsByPath(NestedDatabucket, [REQUEST_INFO, EDIT_REQUEST_PRIORITY])}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={24} style={{ marginTop: "-32px" }}>
                            <Form.Item labelCol={{ span: 24 }} className="form-item-label">
                              <InputField
                                label="Subject"
                                className="form-input"
                                type="text"
                                name="subject"
                                value={subject}
                                placeholder="Select Subject"
                                onChange={(e) => setSubject(e.target.value)}
                              />
                            </Form.Item>
                          </Col>
                          <div className="form-row" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <Row gutter={16} className="form-row-center">
                              <Col span={8} className="form-col" style={{ display: 'flex', gap: '10px' }} >
                                <AntdButton
                                  label="Search"
                                  color="primary"
                                  variant="solid"
                                  htmlType="submit"
                                  className="button-primary"
                                />
                                <AntdButton
                                  label="Clear"
                                  onClick={clearFilters}
                                  style={{
                                    backgroundColor: '#6c757d',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '5px',
                                  }}
                                />
                              </Col>
                            </Row>
                          </div>
                        </Row>
                      </Form>
                    </div>
                  </div>
                  <div className="right-frame">
                    <div style={{ width: prevVisibility ? '81%' : '100%', marginLeft: prevVisibility && 'auto' }}>
                      {/* <div className="d-flex gap-8"> */}
                      <Row gutter={16}>
 
                        <Col span={4}>
                          <SelectInput
                            className="form-select"
                            size="middle"
                            value={filteredStatus}
                            onChange={statusHandler}
                            style={{
                              width: '140px',
                              height: "39px",
                              color: "white",
                              borderRadius: "5px",
                              border: 'none',
                              boxShadow: 'none'
                            }}
                            options={getOptionsByPath(NestedDatabucket, [REQUEST_FILTER, REQUEST_FILTER_STAGE])}
                          />
                        </Col>
                        < Col span={4}>
                          <SelectInput
                            style={{
                              width: '140px',
                              height: "39px",
                              color: "white",
                              borderRadius: "5px",
                              border: 'none',
                              boxShadow: 'none'
                            }}
                            name="clientName"
                            value={clientName || undefined}
                            onChange={(value) => {
                              setClientName(value);
                              dispatch(setFilters({ ...filters, filter: filteredStatus, clientName: value || undefined }));
                              const selectedClient = clientsDataWithEmails.find(
                                (client) => client.NameOfClient === value
                              );
                              setClientEmails(selectedClient ? selectedClient.emails : []);
                              setPage(1);
                              dispatch(fetchAllOrdersThunk({
                                page: 1,
                                pageSize,
                                filter: { ...filter, clientName: value },
                                id: loginUser.id,
                              }));
                            }}
                            placeholder="Select Client's Name"
                            options={clientsData?.map((item) => ({
                              value: item.NameOfClient,
                              label: item.NameOfClient,
                            }))}
                            showSearch
                            filterOption={(input, option) =>
                              option && option.label && option.label.toLowerCase().includes(input.toLowerCase())
                            }
                          />
                        </Col>
                        {/* <Col span={4}>
                          <SelectInput
                            style={{
                              width: '140px',
                              height: "39px",
                              color: "white",
                              borderRadius: "5px",
                              border: 'none',
                              boxShadow: 'none'
                            }}
                            name="clientEmail"
                            value={selectedEmail || undefined}
                            onChange={(value) => {
                              setSelectedEmail(value);
                              dispatch(
                                fetchAllOrdersThunk({
                                  page: 1,
                                  pageSize,
                                  filter: { ...filter, clientName, clientEmail: value },
                                  id: loginUser.id,
                                })
                              );
                            }}
                            placeholder="Select Email"
                            options={clientsDataWithEmails.map((email) => ({
                              value: email,
                              label: email,
                            }))}
                            disabled={clientName}
                            showSearch
                          />
                        </Col> */}
                        <Col span={4}>
                          <AntdButton
                            label="Clear"
                            color="secondary"
                            variant="outline"
                            onClick={() => {
                              setClientName("");
                              setFilteredStatus(DEFAULT_REQUEST_FILTER);
                              setFilter({ filter: DEFAULT_REQUEST_FILTER });
                              dispatch(setFilters({ filter: DEFAULT_REQUEST_FILTER }));
                              setPage(1);
                              dispatch(fetchAllOrdersThunk({
                                page: 1,
                                pageSize,
                                filter: { filter: DEFAULT_REQUEST_FILTER },
                                id: loginUser.id,
                              }));
                            }}
                            style={{
                              borderRadius: "5px",
                              backgroundColor: "#6c757d",
                              color: "white",
                              padding: "4px 10px",
                              height: "38px",
                            }}
                          />
                        </Col>
 
                      </Row>
                      {/* </div> */}
                      <div className="d-flex gap-2 justify-content-end" style={{ marginRight: '1px', marginTop: '-45px', marginBottom: "10px" }}>
 
                        <FontAwesomeIcon
                          icon={faSync}
                          spin={loading}
                          style={{
                            fontSize: 20,
                            color: '#1677ff',
                            cursor: 'pointer',
                            marginRight: 8,
                            alignSelf: 'center',
                          }}
                          title="Refresh"
                          onClick={() => {
                            dispatch(fetchAllOrdersThunk({ page, pageSize, filter, id: loginUser.id }));
                          }}
                        />
                        <AntdButton
                          label="Filter"
                          color='primary'
                          variant='solid'
                          htmlType="submit"
                          style={{ color: 'white' }}
                          icon={<FontAwesomeIcon icon={faFilter} />}
                          onClick={handleFilters}
                        />
                        <AntdButton label="+Add Request" color='primary' variant='solid' htmlType="submit" style={{ color: "white" }} onClick={handleOpen} />
                        <div className="d-flex align-items-center" ref={dropdownRef}>
                          <div className="btn-group">
                            <AntdButton label="Export" color='primary' variant='solid' htmlType="submit"
                              style={{ roundColor: "#007bff", color: "white", marginBottom: "1.75", paddingRight: '1.5rem', borderRadius: '5px' }}
                              id="exportButton"
                              data-bs-toggle="dropdown"
                              aria-expanded={dropDownOpen}
                              icon={<FontAwesomeIcon icon={faCloudArrowDown} />}
                              onClick={() => setDropdownOpen(!dropDownOpen)}
                            />
                            <ul className={`dropdown-menu ${dropDownOpen ? 'show' : ''}`} aria-labelledby="exportButton">
                              <li>
                                <AntdButton label="CSV" className="dropdown-item" onClick={() => handleExport("CSV")} />
                              </li>
                              <li>
                                <AntdButton label="PDF" className="dropdown-item" onClick={() => handleExport("PDF")} />
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
 
                      {/* Data Table */}
                      <div className="row">
                        <div className="col-md-12">
                            <div className="table-responsive">
                              <CustomGridTable
                                rowKey="id"
                                style={{ width: "100%", tableLayout: "auto" }}
                                columns={columns}
                                Id="requests-table"
                                dataSource={rowsWithSerialNumber || []}
                                pagination={{
                                  current: page,
                                  pageSize: pageSize,
                                  onChange: (page, pageSize) => handleTableChange({ current: page, pageSize }),
                                  showQuickJumper: true,
                                  showSizeChanger: false,
                                  total: totalCount,
                                  showTotal: (count, range) => `${range[0]}-${range[1]} of ${count}`,
                                }}
                                loading={loading}
                                locale={
                                  ordersError
                                    ? {
                                        emptyText: (
                                          <div style={{ padding: "24px 12px", textAlign: "center" }}>
                                            <div style={{ color: "#cf1322", fontWeight: 600, marginBottom: 6 }}>
                                              Couldn't load requests
                                            </div>
                                            <div style={{ color: "#8c8c8c", fontSize: 12, marginBottom: 12 }}>
                                              {ordersError}
                                            </div>
                                            <Button
                                              size="small"
                                              onClick={() =>
                                                dispatch(
                                                  fetchAllOrdersThunk({ page, pageSize, filter, id: loginUser.id })
                                                )
                                              }
                                            >
                                              Retry
                                            </Button>
                                          </div>
                                        ),
                                      }
                                    : undefined
                                }
                                scroll={{ x: false }}
                                size="small"
                                onRow={(record) => ({
                                  onClick: () => handleRowClick(record)
                                })}
                              />
                            </div>
 
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            }
          </>
 
        }
      </div>
 
    </div>
  );
 
 
};

export default Requests;